import React from 'react'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import styles from './index.module.less'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import useLang from '../../utils/lang.ts'
import notFoundImg from '../../assets/img/404.png'

function NotFound(props) {
  const [lang] = useLang()
  const { intl } = props
  return (
    <div className={styles.main}>
      <Header style={{ backgroundColor: 'rgba(0,0,0,1)' }} />
      <div className={styles.container}>
        <div className={styles.imgContainer}>
          <img style={{ width: '100%' }} src={notFoundImg} />
        </div>
        <div className={styles.content}>
          <p className={styles.title}>404</p>
          <p className={styles.text}>{intl.formatMessage({ id: 'NotFound' })}</p>
          <Link to={`/home?locale=${lang}`}>
            <Button className={styles.button} type="primary">{intl.formatMessage({ id: 'BackHome' })}</Button>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default injectIntl(NotFound)
